import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectWaysContainerDomain = state => state.waysContainerReducer || initialState;

export const getIsWaysListLoadingSelector = () =>
	createSelector(selectWaysContainerDomain, ({ isWaysListLoading }) => isWaysListLoading);

export const getWaysListSelector = () =>
	createSelector(selectWaysContainerDomain, ({ waysList }) => {
		if (!waysList || waysList.length === 0) {
			return [];
		}

		return waysList;
	});

export const getRawPaginationSelector = () => createSelector(selectWaysContainerDomain, ({ pagination }) => pagination);

export const getPaginationSelector = () =>
	createSelector(selectWaysContainerDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});

export const getTableSearchSelector = () => createSelector(selectWaysContainerDomain, ({ tableSearch }) => tableSearch);
